import { useTranslation } from 'react-i18next';

import { DATA_TRANSLATIONS_EN } from './translations.en';

/** Texte rédigé des données dans la langue active : l'anglais s'il existe, le français sinon. */
export function localizeDataText(text: string, language: string): string {
  if (!language.startsWith('en')) return text;
  return DATA_TRANSLATIONS_EN[text] ?? text;
}

/** Sélecteur à appeler là où un champ rédigé des données est affiché. */
export function useDataText(): (text: string) => string {
  const { i18n } = useTranslation('propfirms');
  const { language } = i18n;
  return (text) => localizeDataText(text, language);
}
